import React from 'react';
import Header from './Header';
import { Solana } from 'iconsax-react';
import InputSelect from '@/components/atoms/InputSelect';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useGetProposalSortLookupQuery } from '@/store/services/biddingProposalsService';

export default function ProposalsHeader() {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === 'ar';
  const [searchParams, setSearchParams] = useSearchParams();
  const sort = searchParams.get('sort');

  const { data: sortLookup } = useGetProposalSortLookupQuery();

  const handleSortChange = (value: string | null) => {
    const nextParams = new URLSearchParams(searchParams);
    if (value) {
      nextParams.set('sort', value);
    } else {
      nextParams.delete('sort');
    }
    setSearchParams(nextParams);
  };

  return (
    <div data-testid="post-details-proposals-header">
      <Header
        icon={
          <Solana
            size="24"
            variant="Bold"
            className="text-light-text-primary dark:text-dark-text-primary"
          />
        }
        title={t('components.postDetails.receivedProposalsTitle')}
        subTitle={t('components.postDetails.receivedProposalsSubtitle')}
        filters={
          <div
            className="flex items-center gap-4"
            data-testid="post-details-proposals-filters"
          >
            {/* Sort Select */}
            <div className="w-[199px] shrink-0" data-testid="post-details-sort-select-wrapper">
              <InputSelect
                id="sort"
                data-testid="post-details-sort-select"
                placeholder={t('components.postDetails.sortPlaceholder')}
                value={sort === 'undefined' ? null : sort}
                onChange={(e) => handleSortChange(e as string)}
                options={sortLookup?.payload?.map((s) => ({
                  label: (isAr && s.nameAr) ? s.nameAr : (s.nameEn || s.name),
                  value: s.code,
                }))}
                className="!w-full [&_.ant-select-selector]:!rounded-[12px] [&_.ant-select-selector]:!min-h-[48px] [&_.ant-select-selector]:!h-[48px] [&_.ant-select-selector]:!flex [&_.ant-select-selector]:!items-center [&_.ant-select-selector]:!px-5 [&_.ant-select-selector]:!bg-light-surface-primary dark:[&_.ant-select-selector]:!bg-dark-surface-primary [&_.ant-select-selector]:!border [&_.ant-select-selector]:!border-light-input-border dark:[&_.ant-select-selector]:!border-dark-input-border [&_.ant-select-selection-placeholder]:!text-light-text-primary dark:[&_.ant-select-selection-placeholder]:!text-dark-text-primary [&_.ant-select-selection-placeholder]:!text-[14px] [&_.ant-select-selection-placeholder]:!font-normal [&_.ant-select-selection-placeholder]:!leading-[100%] [&_.ant-select-selection-item]:!text-light-text-primary dark:[&_.ant-select-selection-item]:!text-dark-text-primary [&_.ant-select-selection-item]:!text-[14px] [&_.ant-select-selection-item]:!font-normal [&_.ant-select-selection-item]:!leading-[100%] [&_.ant-select-arrow]:!text-light-text-primary dark:[&_.ant-select-arrow]:!text-dark-text-primary"
                allowClear
                onClear={() => handleSortChange(null)}
              />
            </div>
          </div>
        }
      />
    </div>
  );
}
